<template>
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :search="search" 
        item-key="id_cuenta"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Cuentas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <div class="text-right" style="margin-top:35px">
                <v-btn class="ma-2" tile color="primary" dark @click="add_new = true">
                    <v-icon left>mdi-plus</v-icon> Añadir nuevo
                </v-btn>
            </div>
            <v-dialog v-model="confirmacion_delete"  max-width="850">
                <v-card>
                    <v-card-title><span class="headline">Eliminar Cuenta</span></v-card-title>
                    <v-card-text>
                        ¿Estas seguro de eliminar esta cuenta?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="confirmacion_delete = false">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="delete_cuenta">Confirmar</v-btn>
                    </v-card-actions>
                </v-card> 
            </v-dialog>
            <v-dialog v-model="add_new"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Añadir nueva cuenta</span>
                    </v-card-title>
                    <v-form ref="form">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-model="new_ob.nombre_cuenta" :rules="[v => !!v || 'Escriba un nombre de cuenta']" label="Nombre"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field type="number" v-model="new_ob.num_cuenta_deducible" label="Núm. Cuenta Deducible"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field type="number" v-model="new_ob.num_cuenta_no_deducible" label="Núm. Cuenta No Deducible"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-select v-model="new_ob.requiere_anexo" :items="items_requiere_anexo" item-text="text" item-value="value" label="Requiere Anexo"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-select v-model="new_ob.es_anexo_comida" :items="items_requiere_anexo" item-text="text" item-value="value" label="Es anexo de comida"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-select v-model="new_ob.requiere_descripcion" :items="items_requiere_anexo" item-text="text" item-value="value" label="Require descripción"></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close_new">Cancelar</v-btn>
                                <v-btn color="blue darken-1" text @click="save_new">Guardar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog v-model="edit"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Editar Cuenta</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editing.nombre_cuenta" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field type="number" v-model="editing.num_cuenta_deducible" label="Núm. Cuenta Deducible"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field type="number" v-model="editing.num_cuenta_no_deducible" label="Núm. Cuenta No Deducible"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-select v-model="editing.requiere_anexo" :items="items_requiere_anexo" item-text="text" item-value="value" label="Requiere Anexo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-select v-model="editing.es_anexo_comida" :items="items_requiere_anexo" item-text="text" item-value="value" label="Es anexo de comida"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-select v-model="editing.requiere_descripcion" :items="items_requiere_anexo" item-text="text" item-value="value" label="Require descripción"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close_edit">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save_edit">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row justify="center">
                <v-col cols="10" sm="10" md="10">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="justify-content-center col-lg-12">      
                <v-alert type="success" :value='alertSucess' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
                <v-alert type="error" :value='alertError' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
            </v-row>
        </template>
        <template v-slot:item.requiere_anexo="{ item }">
            <p v-if="item.requiere_anexo">Sí</p>
            <p v-else>No</p>
        </template>
        <template v-slot:item.es_anexo_comida="{ item }">
            <p v-if="item.es_anexo_comida">Sí</p>
            <p v-else>No</p>
        </template>
        <template v-slot:item.requiere_descripcion="{ item }">
            <p v-if="item.requiere_descripcion">Sí</p>
            <p v-else>No</p>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
import axios from "axios";
import router from '../../router/index.js';

export default {
    data(){
        return {
            headers: [
                { text: "ID", value: "id_cuenta", sortable: true },
                { text: "Nombre", value: "nombre_cuenta", sortable: true },
                { text: "Núm. Cuenta deducible", value: "num_cuenta_deducible", sortable: true },
                { text: "Núm. Cuenta no deducible", value: "num_cuenta_no_deducible", sortable: true },
                { text: "Anexo", value: "requiere_anexo", sortable: true },
                { text: "Es anexo de comida", value: "es_anexo_comida", sortable: true },
                { text: "Requiere descripción", value: "requiere_descripcion", sortable: true },
                { text: "Acciones", value: "actions", sortable: false },
            ],
            items: [],
            selected: [],
            search: '',
            add_new: false,
            new_ob: {
                nombre_cuenta: '',
                num_cuenta_deducible: '',
                num_cuenta_no_deducible: '',
                requiere_anexo: '',
                es_anexo_comida: ''
            },
            isVisible: false,
            message: '',
            alertSucess: false,
            alertError: false,
            editing: {},
            edit: false,
            items_requiere_anexo: [
                { value: true, text: 'Si' },
                { value: false, text: 'No' },
            ],
            selected_item: null,
            confirmacion_delete: false
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        },function(error){
            if(error){
                //console.log(error);
            }  
        });
        // End config for axios
        this.getList();
    },
    methods: {
        getList() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/cuentas").then(res => {
                //console.log(res.data);
                this.items = res.data;
            });
        },
        close_new(){
            this.new_ob.nombre_cuenta = '';
            this.new_ob.num_cuenta_deducible = '';
            this.new_ob.num_cuenta_no_deducible = '';
            this.new_ob.requiere_anexo = '';
            this.new_ob.requiere_descripcion = '';
            this.add_new = false;
            this.$refs.form.reset();
        },
        save_new(){
            if (this.$refs.form.validate()){
                axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/cuentas/",this.new_ob).then(res => {
                    //console.log(res);
                    this.message = res.data.message;
                    this.alertError = false;
                    this.alertSucess = true;

                    this.new_ob.nombre_cuenta = '';
                    this.new_ob.num_cuenta_deducible = '';
                    this.new_ob.num_cuenta_no_deducible = '';
                    this.new_ob.requiere_anexo = '';
                    this.new_ob.es_anexo_comida = '';
                    this.new_ob.requiere_descripcion = '';
                    this.add_new = false;
                    this.getList();
                    this.$refs.form.reset();
                });
            }
        },
        deleteItem(item){
            this.selected_item = item;
            this.confirmacion_delete = true;
        },
        delete_cuenta(){
            axios.delete("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/cuentas/"+this.selected_item.id_cuenta).then(res => {
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;
            
                this.getList();
                this.confirmacion_delete = false;
            });
        },
        editItem(item){
            this.editing = item;
            this.edit = true;
        },
        close_edit(){
            this.editing = {};
            this.edit = false;
        },
        save_edit(){
            axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/cuentas/",this.editing).then(res => {
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;

                this.editing = {};
                this.edit = false;
                this.getList();
            });
        },
    }  
}
</script>

<style>

</style>